<template>
  <div>
    <file-list :fileType="2" :fileList="fileList"></file-list>
  </div>
</template>

<script>
import fileList from "../../components/fileList";
import {roleFilterText} from "@/utils/roleFilter.js"
export default {
  name: "",
  components: { fileList },
  props: {},
  data() {
    return {
      // city:roleFilterText(this.$store.state.region),
      fileList: [
//      {
//        name: `山西省教育厅关于举办2022年山西省职业院校-教学能力比赛通知.pdf`,
//        byte: "10.7M",
//        // download: `《${roleFilterText(this.$store.state.region)}教育局关于举办2022年职业院校技能大赛——教学能力大赛.pdf`,
//      },
//      {
//        name: `${roleFilterText(this.$store.state.region)}关于举办临汾市职业院校技能大赛教学能力大赛通知.pdf`,
//        byte: "107KB",
//        // download: "特色文化育人品牌项目申报书.docx",
//      },
        // {
        //   name: "思政教育工作室项目申报书.docx",
        //   byte: "52KB",
        //   download: "思政教育工作室项目申报书.docx",
        // },
      ],
      fileList1: [
        {
          name: `山西省教育厅关于举办2022年山西省职业院校-教学能力比赛通知.pdf`,
          byte: "10.7M",
          // download: `《${roleFilterText(this.$store.state.region)}教育局关于举办2022年职业院校技能大赛——教学能力大赛.pdf`,
        },
        {
          name: `${roleFilterText(this.$store.state.region)}关于举办临汾市职业院校技能大赛教学能力大赛通知.pdf`,
          byte: "107KB",
          // download: "特色文化育人品牌项目申报书.docx",
        },
        // {
        //   name: "思政教育工作室项目申报书.docx",
        //   byte: "52KB",
        //   download: "思政教育工作室项目申报书.docx",
        // },
      ],
    };
  },
  computed: {},
  watch: {},
  created() {
  	
  	if(roleFilterText()=='' || roleFilterText()==undefined){
  		this.fileList=[];
  	}else{
  		this.fileList=this.fileList1;
  	}
  },
  mounted() {},
  methods: {},
};
</script>

<style scoped lang="scss">
$width: 50px;
$color: #ff8040;
.about {
  h1 {
    color: $color !important;
  }
}
</style>
